import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import { useConfig } from "../lib/config";

export default function Footer() {
  const cfg = useConfig();
  const waLink = cfg.whatsapp
    ? `https://wa.me/${cfg.whatsapp.replace(/\D/g, "")}`
    : "#";
  return (
    <footer className="border-t border-gray-200 bg-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-2 mb-6">
            <span className="w-8 h-8 bg-[#059669] flex items-center justify-center">
              <span className="text-white font-display text-sm">FD</span>
            </span>
            <span className="font-display text-lg tracking-tight">
              FARDRIVER <span className="text-[#059669]">TÜRKİYE</span>
            </span>
          </Link>
          <p className="text-sm text-gray-600 leading-relaxed max-w-md">
            Türkiye'nin elektrikli motosiklet kontrolör tedarikçisi. 0-30KW güç aralığında FOC sürüş teknolojisi,
            Bluetooth uygulama desteği ve profesyonel servis hizmeti.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gray-500">
            <span className="w-2 h-2 bg-emerald-500 rounded-full inline-block" />
            Türkiye Tedarikçisi
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#059669] mb-4">Site Haritası</p>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-[#059669]" to="/urunler">Ürünler</Link></li>
            <li><Link className="hover:text-[#059669]" to="/rehber">Rehber</Link></li>
            <li><Link className="hover:text-[#059669]" to="/hakkimizda">Hakkımızda</Link></li>
            <li><Link className="hover:text-[#059669]" to="/iletisim">İletişim</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#059669] mb-4">İletişim</p>
          <ul className="space-y-3 text-sm text-gray-700">
            <li className="flex items-start gap-3">
              <Phone size={16} className="mt-0.5 text-gray-400" />
              <a href={`tel:${cfg.phone}`} className="hover:text-[#059669]" data-testid="footer-phone">
                {cfg.phone || "+90 212 555 5555"}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={16} className="mt-0.5 text-gray-400" />
              <a href={`mailto:${cfg.email}`} className="hover:text-[#059669]" data-testid="footer-email">
                {cfg.email || "info@fardriverturkiye.com"}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MessageCircle size={16} className="mt-0.5 text-gray-400" />
              <a href={waLink} target="_blank" rel="noreferrer" className="hover:text-[#059669]" data-testid="footer-whatsapp">
                WhatsApp ile mesaj at
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 text-gray-400" />
              <span>İstanbul, Türkiye</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-gray-500">
          <p>© {new Date().getFullYear()} Fardriver Türkiye. Tüm hakları saklıdır.</p>
          <p className="font-mono-fd">fardriverturkiye.com</p>
        </div>
      </div>
    </footer>
  );
}
